import config from 'config/config'
import { I18n } from 'lib/i18n'
import { del, get, patch, post } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'

export const LOAD = 'discounts/LOAD'
export const LOAD_DONE = 'discounts/LOAD_DONE'
export const LOAD_FAILED = 'discounts/LOAD_FAILED'

export const SAVE = 'discounts/SAVE'
export const SAVE_DONE = 'discounts/SAVE_DONE'
export const SAVE_FAILED = 'discounts/SAVE_FAILED'

export const DELETE = 'discounts/DELETE'
export const DELETE_DONE = 'discounts/DELETE_DONE'
export const DELETE_FAILED = 'discounts/DELETE_FAILED'

export const loadDiscounts = () => ({ type: LOAD })
export const loadDiscountsFulfilled = (discounts) => ({
  type: LOAD_DONE,
  discounts,
})
export const loadDiscountsFailed = () => ({ type: LOAD_FAILED })

export const saveDiscount = (discount) => ({ type: SAVE, discount })
export const saveDiscountFulfilled = () => ({ type: SAVE_DONE })
export const saveDiscountFailed = () => ({ type: SAVE_FAILED })

export const deleteDiscount = (id) => ({ type: DELETE, id })
export const deleteDiscountFulfilled = () => ({ type: DELETE_DONE })
export const deleteDiscountFailed = () => ({ type: DELETE_FAILED })

const initialState = {
  discounts: [],
  discountsLoading: false,
}

export const discountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, discountsLoading: true }
    case LOAD_DONE:
      return { ...state, discountsLoading: false, discounts: action.discounts }
    case SAVE:
      return { ...state, discountSaving: true }
    case SAVE_DONE:
      return { ...state, discountSaving: false }
    case SAVE_FAILED:
      return { ...state, discountSaving: false, errors: action.errors }
    case DELETE:
      return { ...state, deletingDiscount: true }
    case DELETE_DONE:
      return { ...state, deletingDiscount: false }
    default:
      return state
  }
}

//export const loadEpic = (action$, store) =>
//  action$.ofType(LOAD)
//    .mergeMap(() => [loadDiscountsFulfilled(discounts.slice())]);

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/discounts'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadDiscountsFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.discounts/LOAD_FAILED'))
        return [loadDiscountsFailed(result.body.errors)]
      }
    })

export const saveEpic = (action$, store) =>
  action$
    .ofType(SAVE)
    .filter((action) => action.discount.id !== undefined)
    .mergeMap((action) => {
      const { code, name, ...discount } = action.discount
      return patch('/discounts/' + action.discount.id, {
        discount: { ...discount, code: code || null, name: name || null },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.discount/SAVE_DONE'))
        return [saveDiscountFulfilled(), loadDiscounts()]
      } else {
        toast.error(I18n.t('action.discount/SAVE_FAILED'))
        return [saveDiscountFailed(result.body.errors)]
      }
    })

export const createEpic = (action$, store) =>
  action$
    .ofType(SAVE)
    .filter((action) => action.discount.id === undefined)
    .map((discount) => ({
      ...discount,
      code: discount.code || null,
      name: discount.name || null,
    }))
    .mergeMap((action) => {
      const { code, name, ...discount } = action.discount
      return post('/discounts', {
        discount: { ...discount, code: code || null, name: name || null },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.discount/CREATE_DONE'))
        return [
          saveDiscountFulfilled(),
          loadDiscounts(),
          push(config.nodes.discount),
        ]
      } else {
        toast.error(I18n.t('action.discount/CREATE_FAILED'))
        return [saveDiscountFailed(result.body.errors)]
      }
    })

export const deleteEpic = (action$, store) =>
  action$
    .ofType(DELETE)
    .mergeMap((action) => del('/discounts/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.discount/DELETE_DONE'))
        return [
          deleteDiscountFulfilled(),
          loadDiscounts(),
          push(config.nodes.discount),
        ]
      } else {
        toast.error(I18n.t(`action.${SAVE_FAILED}`))
        return [deleteDiscountFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/discounts.js